<template>
  <div class="schedule-section">
    <div class="schedule-section__heading">
      <h2 v-if="dayIndex == 0">VIEW YOUR FULL ITINERARY</h2>
      <h2 v-else></h2>
      <h2>{{ date | formatDate | uppercase }}</h2>
    </div>
    <ScheduleTime v-for="({starts_at, ends_at, entries}, x) in times" :key="x" :starts_at="starts_at" :ends_at="ends_at" :entries="entries" />
  </div>
</template>

<script>
import _ from 'lodash'
import ScheduleTime from './ScheduleTime.vue'

export default {
  name: 'ScheduleDate',
  props: ['date', 'entries', 'dayIndex'],
  components: { ScheduleTime },
  computed: {
    times() {
      let groupedEntries = _.groupBy(this.entries, (entry) => {
        return [entry.starts_at, entry.ends_at]
      })

      groupedEntries = Object.values(groupedEntries)

      return groupedEntries.map((entries) => {
        return {
          starts_at: entries[0].starts_at,
          ends_at: entries[0].ends_at,
          entries: entries
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>

</style>
